import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BarnModuleState } from '../../models/barn.model';
import { adapter, initialState } from '../reducers/barn.reducer';

const { selectAll } = adapter.getSelectors();

export const getBarnModuleState = createFeatureSelector<BarnModuleState>('barnModule');

export const getBarnState = createSelector(
  getBarnModuleState,
  (state) => state?.barns ?? initialState.barns,
);

export const getSelectedBarnId = createSelector(RouterSelectors.getMergedRoute, (state) =>
  !isNaN(parseInt(state.params['barnId'], 10)) ? parseInt(state.params['barnId'], 10) : undefined,
);

export const getBarns = createSelector(getBarnState, selectAll);

export const getSelectedBarn = createSelector(
  getBarnModuleState,
  (state) => state?.selectedBarn ?? initialState.selectedBarn,
);

export const getSilos = createSelector(
  getBarnModuleState,
  (state) => state?.silos ?? initialState.silos,
);
